<template>
  <div class="active-company-switcher">
    <ResourceAction
      ref="getCompaniesLimitsResource"
      :action="action"
      @success="onLoadLimitsData"
      v-slot="{ isLoading }"
    >
      <DropdownTarget
        v-if="!isLoading && activeCompany"
        ref="target"
        v-slot="{ visible, hide, show }"
      >
        <button
          @click="visible ? hide() : show()"
          class="active-company-switcher__wrapper"
        >
          <span class="active-company-switcher__active">
            <img
              class="active-company-switcher__active-image"
              :src="activeCompany.logoUrl"
              :alt="`Логотип компании «${activeCompany.title}»`"
            />
            <span
              :class="
                bem('active-company-switcher__active-limit', {
                  expired:
                    activeCompany.limit === 0 &&
                    activeCompany.limitStatus === 'with_limits',
                })
              "
              class="active-company-switcher__active-limit"
              >{{ activeCompanyLimit }}</span
            >
            <ArrowIcon
              direction="bottom"
              size="24"
              color="muted"
              class="active-company-switcher__active-arrow"
            />
          </span>
        </button>
        <TransitionFade>
          <BasicDropdown v-if="visible" respect-target>
            <div class="active-company-switcher__suggestions">
              <a
                v-for="(company, index) in companies"
                :key="index"
                :href="`/companies/${company.alias}/select`"
                class="active-company-switcher__item"
                :class="
                  bem('active-company-switcher__item', {
                    active: activeCompany.alias === company.alias,
                  })
                "
              >
                <img
                  class="active-company-switcher__item-image"
                  :src="company.logoUrl"
                  :alt="`Логотип компании «${company.title}»`"
                />
                <div class="active-company-switcher__item-info">
                  <div class="active-company-switcher__item-title">
                    {{ company.title }}
                  </div>
                  <div
                    :class="
                      bem('active-company-switcher__item-count', {
                        expired:
                          company.limit === 0 &&
                          company.limitStatus === 'with_limits',
                      })
                    "
                    class="active-company-switcher__item-count"
                  >
                    {{ getCompanyLimitText(company) }}
                  </div>
                </div>
              </a>
            </div>
          </BasicDropdown>
        </TransitionFade>
      </DropdownTarget>
    </ResourceAction>
  </div>
</template>

<script>
import { PersonalResource } from 'src/services/personal.js';
import { bem } from 'src/utils/bem.js';
import { getRussianPluralDeclension } from 'src/utils/translation.js';

import BasicDropdown from 'src/components/BasicDropdown/BasicDropdown.vue';
import DropdownTarget from 'src/components/DropdownTarget/DropdownTarget.vue';
import ArrowIcon from 'src/components/icons/ArrowIcon/ArrowIcon.vue';
import ResourceAction from 'src/components/ResourceAction/ResourceAction.vue';
import TransitionFade from 'src/components/transitions/TransitionFade/TransitionFade.vue';

const profileLeftDeclension = getRussianPluralDeclension(
  'Осталось ${0} открытие контактов',
  'Осталось ${0} открытия контактов',
  'Осталось ${0} открытий контактов',
);

const profileDeclension = getRussianPluralDeclension(
  '${0} контакт',
  '${0} контакта',
  '${0} контактов',
);

export default {
  name: 'ActiveCompanySwitcher',
  components: {
    BasicDropdown,
    TransitionFade,
    DropdownTarget,
    ResourceAction,
    ArrowIcon,
  },
  data() {
    return {
      companies: null,
    };
  },
  mounted() {
    this.$refs.getCompaniesLimitsResource.dispatch();
  },
  methods: {
    bem,
    action: PersonalResource.getCompaniesLimits,
    onLoadLimitsData({ data }) {
      this.companies = data.user_companies;
    },
    getCompanyLimitText(company) {
      if (company.limitStatus === 'old_access') {
        return 'Есть доступ';
      }
      if (company.limitStatus === 'access_end') {
        return 'Нет доступа';
      }
      const value = company.limit;
      return `${profileDeclension(value).replace('${0}', value)}`;
    },
  },
  computed: {
    activeCompany() {
      if (!this.companies) return null;
      return this.companies.find((company) => company.active);
    },
    activeCompanyLimit() {
      if (this.activeCompany.limitStatus === 'old_access') {
        return 'Есть доступ к базе';
      }
      if (this.activeCompany.limitStatus === 'access_end') {
        return 'Нет доступа к базе';
      }
      const value = this.activeCompany.limit;
      return `${profileLeftDeclension(value).replace('${0}', value)}`;
    },
  },
};
</script>
